<template>
  <div id="storeListPage">
    <NavBar :active="activeNav" class="overflow-y-hidden"/>
<!--    <div class="row">-->
<!--      <div class="col-12 col-md-8 col-lg-6 mx-auto">-->
        <v-main class="overflow-hidden">
          <div class="has-footer-payments">
            <div class="container-fluid">
              <ProductsOrStoreCategories :categories="storeCategories"/>
              <div class="row ">
                <div class="col  pt-0 pl-0">
                  <v-text-field
                      v-model="searchKeyWord"
                      append-icon="far fa-magnifying-glass"
                      class="rounded-lg"
                      clearable
                      dense
                      flat
                      hide-details
                      solo
                      @keydown="search"
                      @click:clear="clearSearchResult">
                  </v-text-field>
                </div>
                <div class="col-auto  pt-0 px-0">
                  <v-btn id="category" icon @click="category = true">
                    <i class="fa-solid fa-list-check fa-xl"></i>
                  </v-btn>
                </div>
                <div class="col-auto pt-0 px-0">
                  <v-btn icon @click="openSortBox">
                    <i class="fa-solid fa-sliders fa-xl"></i>
                  </v-btn>
                </div>
              </div>
              <h1 class="col-8 primary-text col-12">{{ title }}</h1>

              <div v-if="stores.length=== 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  موردی یافت نشد
                </div>

              </div>
              <div class="row">

                <div v-for="item in stores" :key="item.id" class="col-4 p-1 col-md-3 col-lg-2">
                  <StoreCard :item="item"/>
                </div>
              </div>
            </div>
            <div>
              <PaymentsFooter :current-page="'stores'" :is-in-online-payment="isOnline"/>
            </div>
            <div id="sliderMenu" class="border-bottom mx-1">
              <div id="slideMenuWarpper">
                <div id="darkOverlay" class="dark-overlay"></div>
                <nav id="example-menu2" class="slide-menu rounded-l-lg">
                  <v-btn icon @click="closeDrawer">
                    <i class="fa-solid fa-circle-xmark fa-xl"></i>
                  </v-btn>
                  <div class="row mx-2 light-gray-bg  rounded-lg">
                    <div class="col-3 "><i class="fa-solid fa-list-check fa-xl"></i></div>
                    <div class="col-9 "> دسته بندی بازار ها</div>
                  </div>
                  <ul id="categoryNavDrawer">
                    <li v-for="(Item,index) in items" :key="index">
                      <a class="py-2" href="#"
                         @click="checkToGoToStoreList(Item.Children,Item.Item.ShoppingCategoryID)">{{
                          Item.Item.Name
                        }}</a>
                      <ul v-if="Item.Children.length > 0">
                        <li v-for="(child,i) in Item.Children" :key="i">
                          <a class="py-2" href="#"
                             @click="checkToGoToStoreList(child.Children,child.Item.ShoppingCategoryID)">
                            {{ child.Item.Name }}
                          </a>
                          <ul v-if="child.Children.length > 0">
                            <li v-for="(child2,j) in child.Children" :key="j">
                              <a class="py-2" href="#"
                                 @click="checkToGoToStoreList(child2.Children,child2.Item.ShoppingCategoryID)">
                                {{ child2.Item.Name }}
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div id="sortBox" class="sort-box bg-white p-2">
              <v-btn icon @click="closeSortBox">
                <i class="fa-solid fa-circle-xmark fa-xl"></i>
              </v-btn>
              <div class="row mx-2 light-gray-bg  rounded-lg ">
                <div class="col-3 "><i class="fa-solid fa-sliders fa-xl"></i></div>
                <div class="col-9 ">مرتب سازی</div>
              </div>
              <v-radio-group v-model="filterSelected">
                <v-radio
                    v-for="(item,i) in filterItems"
                    :key="i+1"
                    :label="item"
                    :value="i+1"
                    @change="sort(i+1)"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>


        </v-main>
<!--      </div>-->

<!--    </div>-->
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import PaymentsFooter from "@/components/PaymentsFooter";
import ProductsOrStoreCategories from "@/components/ProductsOrStoreCategories";
import StoreCard from "@/components/StoreCard";
import NavBar from "@/components/NavBar";

let menu = null;

export default {
  name: "StoreList",
  metaInfo: {
    title: 'ایوان خانه- فروشگاه ها',
  },
  components: {NavBar, PaymentsFooter, StoreCard, ProductsOrStoreCategories,},
  data: () => ({
    storeCategories: [],
    storeCategoriesLoading: true,
    stores: [],
    items: [],
    category: false,
    showLoaderDialog: false,
    filterSelected: 1,
    filterItems: ['پیش فرض', 'جدیدترین', 'قدیمی ترین', 'پربازدید ترین', 'محبوب ترین'],
    isOnline: null,
    pageIndex: 1,
    itemsPerPage: 20,
    userSelectedTypeSort: false,
    categoryID: null,
    typeSortSelected: null,
    searchKeyWord: null,
    activeNav: null,
    title: null,


  }),
  watch: {
    '$route.query'() {
      this.categoryID = this.$route.query.ShoppingCategoryID
      this.getStoresList();
      this.title = this.$route.query.Name
    },
  },
  mounted() {
    this.categoryID = this.$route.query.ShoppingCategoryID
    if (this.$route.query.type !== undefined) {
      if (this.$route.query.type === '2') {
        this.title = 'جدیدترین'
        this.userSelectedTypeSort = 2
      } else if (this.$route.query.type === 'true') {
        this.title = ' فروشگاه های برتر'

      }
    }
    if (this.$route.query.title !== undefined) {
      this.title = this.$route.query.title
    }
    this.initData()
    this.getStoresCategories()

    this.isOnline = this.$route.query.isOnline
    if (this.isOnline === 'true') {
      this.activeNav = 'online'
    } else {
      this.activeNav = 'offline'
    }
    this.getStoresList()
  },
  destroyed() {
    window.onscroll = null
  },

  methods: {
    /* scroll() {
       window.onscroll = () => {
         let bottomOfWindow = (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight + 3).toFixed(0) > document.documentElement.offsetHeight
         if (bottomOfWindow) {

           this.getStoresList()
         }

       }
     },*/

    checkToGoToStoreList(child, id) {
      if (child.length === 0) {
        const menu = document.getElementById('example-menu2')._slideMenu;
        menu.close();
        document.body.classList.remove('slide-menu-opened');
        this.goToStoreList(id)
      }
    },
    goToStoreList(id) {
      this.$router.push({path: 'StoreList', query: {isOnline: this.isOnline, ShoppingCategoryID: id}})

    },
    getStoresCategories() {
      let requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/AllShoppingCategoriesApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let list = json.list.filter(x => x.IsActive === true);
            for (let i = 0; i < list.length; i++) {
              list[i].id = list[i].ShoppingCategoryID
            }
            this.storeCategories = list

          })
          .catch(error => console.log('error', error));
    },
    getStoresList() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      if (this.activeNav === 'online') {
        urlencoded.append("IsOnlineVendor", 'true');

      } else {
        urlencoded.append("IsOnlineVendor", 'false');

      }
      urlencoded.append("pageIndex", 1);
      urlencoded.append("pageSize", "10000");
      if (this.categoryID !== undefined) {
        urlencoded.append("ShoppingCategoryID", this.categoryID);
      }
      if (this.userSelectedTypeSort === true) {
        urlencoded.append("TypeSearchEngineVendorSort", this.typeSortSelected);
      }
      if (this.searchKeyWord !== null && this.searchKeyWord !== '') {
        urlencoded.append("KeyWord", this.searchKeyWord);
      }
      if (this.$route.query.type === 'true') {
        urlencoded.append("IsVipBrand", 'true');
      }


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/_ListVendor", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.stores = (json.VendorViewModel)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },

    initData() {
      let requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };

      fetch("https://api.eyvankhaneh.app/CommonMethod/AllShoppingCategoryApiV2", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.items = JSON.parse(result)
            setTimeout(function () {
              new window.SlideMenu(document.getElementById('example-menu2'), {
                position: "right",
                showBackLink: true,
                submenuLinkAfter: '<i class="fa-solid fa-arrow-left"></i>',
              });

              let myAnchor = document.getElementById("category");
              myAnchor.onclick = function () {
                menu = document.getElementById('example-menu2')._slideMenu;
                menu.toggle();
              }

              let menuElement = document.getElementById('example-menu2');
              menuElement.addEventListener('sm.open', function () {
                document.body.classList.toggle('slide-menu-opened');
              });

              menuElement.addEventListener('sm.close', function () {
                document.body.classList.toggle('slide-menu-opened');
              });


              let overLay = document.getElementById("darkOverlay");
              overLay.onclick = function () {
                const menu = document.getElementById('example-menu2')._slideMenu;
                menu.close();
              }
            }, 100)

          })
          .catch(error => console.log('error', error));
    },
    closeDrawer() {
      menu.close();
    },
    openSortBox() {
      document.getElementById('sortBox').classList.add('open')
    },
    closeSortBox() {
      document.getElementById('sortBox').classList.remove('open')

    },
    sort(i) {
      this.userSelectedTypeSort = true
      this.typeSortSelected = i
      if (this.$route.query.Name === undefined && this.$route.query.title === undefined) {
        this.title = this.filterItems[i - 1]
      }
      this.closeSortBox()
      this.getStoresList()
    },
    search(e) {
      if (e.keyCode === 13) {
        this.getStoresList()
      }
    },
    clearSearchResult() {
      this.searchKeyWord = null
      this.getStoresList()
    }

  }
}
</script>



